import React from 'react';
import ReactApexChart from 'react-apexcharts';
import Tooltip from "@mui/material/Tooltip";
import { BsInfoCircle } from 'react-icons/bs';
import useWindowDimensions, { humanReadable } from '../../../../../utils/useWindowDimensions';
import { EnlargeIcon } from '../../../../../assets/icons/iconshere';

const Error = ({ errorSpider, setErrorEnlarge }) => {
    let { width, height } = useWindowDimensions();
    
    const chartData = {
        series: [
            {
                name: 'First Iteration',
                data: errorSpider.map((e) => e.first),
            },
            {
                name: 'Last Iteration',
                data: errorSpider.map((e) => e.last),
            },
        ],
        options: {
            chart: {
                type: 'radar',
                toolbar: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: true,
            },
            plotOptions: {
                radar: {
                    size: width > 1500 ? 120 : 100,
                    polygons: {
                        strokeColors: '#e9e9e9',
                        fill: {
                            colors: ['#f8f8f8', '#fff']
                        }
                    }
                }
            },
            colors: ['#3e4095', '#333333'],
            markers: {
                size: 5,
                colors: ['#fff'],
                strokeColor: '#3e4095CC',
                strokeWidth: 1,
            },
            tooltip: {
                x: {
                    formatter: (value, { dataPointIndex }) => {
                        const name = errorSpider[dataPointIndex].name;
                        return `${name}`;
                    }
                },
                y: {
                    formatter: (value) => {
                        return `${humanReadable(value)}`;
                    }
                }
            },
            xaxis: {
                categories: errorSpider.map(e => e.name.split(" ")[0])
            },
            yaxis: {
                tickAmount: 8,
                labels: {
                    formatter: function (val, i) {
                        if (i % 2 === 0) {
                            return val;
                        } else {
                            return '';
                        }
                    }
                }
            }
        }
    };

    return (
        <>
            <div className="cardbox overflow-hidden">
                <div className='d-flex justify-content-between align-items-center mt-1'>
                    <h5 className='mb-1'>Errors</h5>
                    <p className="text_enlarge_option mb-1">
                        <Tooltip title="View more">
                            <span className="enlargebtn" onClick={()=> setErrorEnlarge(true)}>
                                <EnlargeIcon />
                            </span>
                        </Tooltip>
                    </p>
                </div>
                <div id="chart" className='pt-3 langchart'>
                    <ReactApexChart 
                        options={chartData.options} 
                        series={chartData.series} 
                        type="radar" 
                        height={width > 1500 ? 355 : 327} 
                        width={350} 
                    />
                </div>
            </div>
        </>
    );
}

export default Error;
